import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSettingsDictionary, useAssetsIcons } from '@/shared/api';
import { useAppSettingsStore } from '@/shared/lib';
import type { BaseAsset } from '@/shared/types';
import CurrencyIcon from '@/shared/assets/currency-icon.svg?react';
import { OptionListRow, type OptionListItem } from './OptionListRow';

type Props = {
  isTabletUp: boolean;
};

export function CurrencyRow({ isTabletUp }: Props) {
  const { t } = useTranslation();
  const { baseAsset, setBaseAsset } = useAppSettingsStore();
  const { appSettingsData } = useAppSettingsDictionary();
  const { assetsIconsData } = useAssetsIcons();

  const items = useMemo<OptionListItem[]>(
    () =>
      (appSettingsData?.value.accountAssets ?? []).map(asset => ({
        key: asset.code,
        label: asset.code,
        icon: assetsIconsData?.value?.[asset.code],
      })),
    [appSettingsData, assetsIconsData]
  );

  return (
    <OptionListRow
      icon={<CurrencyIcon />}
      label={t('personalAccount.balanceDropdown.currency')}
      valueLabel={baseAsset}
      items={items}
      onSelect={key => setBaseAsset(key as BaseAsset)}
      isTabletUp={isTabletUp}
    />
  );
}
